import React, { useEffect, useState, useRef } from 'react';
import { Check, FileText, X, UploadCloud } from 'lucide-react';
import { SmartFilenameParser } from '../../utils/SmartFilenameParser';
import { SaveCancelBar } from '../../components/ui/SaveCancelBar';

export default function ZoteroEditModal({ isOpen, initialData, onClose, onSave }) {
  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState({ title: '', author: '', year: '', summary: '', fileName: '' });

  useEffect(() => {
    if (isOpen && initialData) {
      setFormData({
        title: initialData.title || '',
        author: initialData.author || '',
        year: initialData.year || '',
        summary: initialData.citation_text || initialData.summary || '',
        fileName: ''
      });
    }
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const parsed = SmartFilenameParser.parse(file.name);
    setFormData(prev => ({
        ...prev,
        fileName: file.name,
        title: parsed.success ? parsed.title : prev.title || parsed.title,
        author: parsed.success ? parsed.author : prev.author,
        year: parsed.success ? parsed.year : prev.year
    }));
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white w-full max-w-lg rounded-xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
        <div className="bg-[#20243B] p-4 flex justify-between items-center text-white">
          <h2 className="font-bold flex items-center gap-2"><FileText className="w-5 h-5 text-[#C5A059]"/> Editar Documento</h2>
          <button onClick={onClose}><X className="w-6 h-6"/></button>
        </div>
        <div className="p-6 space-y-4 overflow-y-auto">
          <div className="border-2 border-dashed border-gray-300 rounded-xl p-4 text-center cursor-pointer hover:bg-gray-50" onClick={() => fileInputRef.current.click()}>
            <input type="file" ref={fileInputRef} className="hidden" accept=".pdf" onChange={handleFileSelect} />
            <UploadCloud className="w-8 h-8 text-gray-400 mx-auto mb-2"/>
            <p className="text-xs font-bold text-gray-600">{formData.fileName || "Clique para substituir PDF (Smart Upload)"}</p>
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-500 uppercase">Título</label>
            <input name="title" value={formData.title} onChange={handleChange} className="w-full border p-2 rounded text-sm"/>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="text-[10px] font-bold text-gray-500 uppercase">Autor</label><input name="author" value={formData.author} onChange={handleChange} className="w-full border p-2 rounded text-sm"/></div>
            <div><label className="text-[10px] font-bold text-gray-500 uppercase">Ano</label><input name="year" value={formData.year} onChange={handleChange} className="w-full border p-2 rounded text-sm"/></div>
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-500 uppercase">Citação (ABNT)</label>
            <textarea name="summary" rows={3} value={formData.summary} onChange={handleChange} className="w-full border p-2 rounded text-sm font-serif"/>
          </div>
        </div>
        <div className="p-4 bg-gray-50 border-t">
          <SaveCancelBar
            onCancel={onClose}
            onSave={() => onSave(formData)}
            cancelLabel="Cancelar"
            saveLabel="Salvar"
          />
        </div>
      </div>
    </div>
  );
}